import { Stack, Text } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { PlatformAlert } from '@/components/ui-shared/PlatformAlert/PlatformAlert'

export const OcrAnnotationInfo = () => {
  return (
    <PlatformAlert variant="info" showIcon={false} compact>
      <Stack>
        <Text fw={600} size="xs">
          <FormattedMessage id="annotation.ocr.banner.title" />
        </Text>

        <Text size="xs">
          <FormattedMessage id="annotation.ocr.banner.description1" />
        </Text>

        <Text size="xs">
          <FormattedMessage id="annotation.ocr.banner.description2" />
        </Text>

        <Text size="xs">
          <FormattedMessage id="annotation.ocr.banner.tip.works" />
        </Text>

        <Text size="xs">
          <FormattedMessage id="annotation.ocr.banner.tip.notWorks" />
        </Text>
      </Stack>
    </PlatformAlert>
  )
}
